<template>
    <div class="app_main">
        <div class="tac_right">
            <div class="tac_right_top">
                <Navigation></Navigation>
            </div>
            <div class="tac_right_main">
                <router-view/>
            </div>
        </div>
    </div>

</template>
<script>
import Navigation from "@/components/navigation";

export default {
    components: {
        Navigation,
    },
    data() {
        return {
            navselected: 'home',
            editableTabsValue: '1',
            editableTabs: [],
            tabIndex: 1,
            isOpenCallNumber: false,
            waitCnt: 0,
            jumpCnt: 0,
            callCnt: 0,
            waitingList: [],
            jumpList: [],
            callingList: [],
            callingName: null,
            callNumberTab: 'wait',
            callNumberList: [],
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            countdown: 0, // 倒计时字段
            isCounting: false, // 是否正在倒计时
        }
    },
    created() {
        // this.getQuickPanelDataInfo(); // 叫号快捷面板查询
    },
    mounted() {
        this.navselected = this.$route.name;
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
            this.isOpenCallNumber = false;
        },
        getNavType() {
            this.navselected = this.$store.state.adminleftnavnum;
            console.log(this.navselected)
        },
        getCurrentRouteTitle() {
            console.log(this.$store.state.actRouterTitle);
            let actRouterTitle = this.$store.state.actRouterTitle;
            if (actRouterTitle !== '工作台' && this.navselected !== 'home') {
                // this.addTab(actRouterTitle);
            }
        },
    },
    watch: {
        // 监测store.state
        '$store.state.adminleftnavnum': 'getNavType',
        '$store.state.actRouterTitle': 'getCurrentRouteTitle'
    }
}
</script>


<style scoped lang="scss">
    @import "@/assets/styles/admin.scss";
</style>
